import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

const MODELLO_DICHIARAZIONE_BOLLI =
  '/assets/modelli/DICHIARAZIONE-ANNULLAMENTO-MARCA-DA-BOLLO.docx';

const today = new Date();
today.setHours(0, 0, 0, 0); // Rimuovo il tempo dall'oggetto Date per confrontare solo le date

const startDate = new Date(today.setDate(today.getDate()));
const filter = new Date(today.setDate(today.getDate() + 1));

const filterDate = (d: Date | null): boolean => {
    return d !== null && d < filter;
};
export const AllegatiBolliAltroStep: FormlyFieldConfig[] = [
    {
        key: 'allegati_documentazione_altro',
        type: 'mat-upload',
        props: {
            label: 'ALTRA DOCUMENTAZIONE',
            multiple: true,
        },
    },
    // versamento dell imposta di AllegatiBolliAltroStep, marca per a
    {
        fieldGroupClassName:
            'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 w-full px-7 py-3',
        fieldGroup: [
            {
                template: `
									<div class="mt-3  mb-4">
											<h3 class="font-semibold text-white inline-block rounded bg-primary py-1 px-3">
													DICHIARAZIONE RELATIVA ALL'ASSOLVIMENTO DELL'IMPOSTA DI BOLLO
											</h3>
									</div>
							`,
            },
      {
        key: 'dichiarazione_bolli',
        type: 'mat-upload',
        props: {
          label: "Allega la dichiarazione relativa all'assolvimento dell'imposta di bollo",
          description:
            "Dichiarazione relativa all'assolvimento dell'imposta di bollo.",
          required: true,
        },
      },
      {
        template: `
          <div class="text-base mb-2">
            Modello scaricabile:
            <a
              href="${MODELLO_DICHIARAZIONE_BOLLI}"
              target="_blank"
              rel="noopener noreferrer"
              class="text-blue-600 underline font-semibold"
              download
            >
              DICHIARAZIONE SOSTITUTIVA PER MARCA DA BOLLO
            </a>
          </div>
        `
      },




 
    ],
    },
];
